import React from 'react';
import LandingNav from '../components/LandingNav';
import Button from '../components/Button';
import Footer from '../components/Footer';
import './Landing.css';

const Landing = () => {
  const features = [
    {
      title: 'Smart Calendar',
      description: 'Plan content across all platforms with drag-and-drop simplicity.'
    },
    {
      title: 'AI Assist',
      description: 'Generate captions, ideas, hashtags, titles and more instantly.'
    },
    {
      title: 'Unified Inbox',
      description: 'Reply to comments, messages, and mentions without switching apps.'
    },
    {
      title: 'Analytics',
      description: 'Track growth, engagement, and performance across platforms.'
    }
  ];

  const pricingPlans = [
    {
      name: 'Starter',
      price: '$9/mo',
      features: ['Up to 3 social accounts', 'Basic scheduling', 'Email support'],
      popular: false
    },
    {
      name: 'Creator',
      price: '$19/mo',
      features: ['Up to 10 social accounts', 'AI Assist tools', 'Analytics', 'Unified inbox'],
      popular: true
    },
    {
      name: 'Pro',
      price: '$49/mo',
      features: ['Unlimited accounts', 'Advanced analytics', 'Priority support', 'Custom reporting'],
      popular: false
    }
  ];

  return (
    <div className="landing-page">
      <LandingNav />

      <section className="hero">
        <h1>
          The All-In-One Social Hub <br /> Built for Creators & Teams
        </h1>
        <p>Plan, schedule, publish, analyze, and grow — all in one simple dashboard.</p>

        <div className="cta">
          <Button variant="primary" to="/login">
            Get Started Free
          </Button>
          <Button variant="secondary" onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}>
            Explore Features
          </Button>
        </div>

        <img src="/images/dashboard-preview.png" alt="Dashboard Preview" className="hero-img" />
      </section>

      <section id="features" className="features">
        <h2>Everything You Need. In One Place.</h2>

        <div className="grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="pricing" className="pricing">
        <h2>Simple Plans for Every Creator</h2>
        <div className="pricing-row">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`price-card ${plan.popular ? 'popular' : ''}`}>
              <h3>{plan.name}</h3>
              <p className="price">{plan.price}</p>
              <ul>
                {plan.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <Button variant="primary">
                {plan.name === 'Starter' ? 'Start Free' : 'Choose Plan'}
              </Button>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Landing;
